import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Capsules",
  [
    [
      "path",
      {
        d: "M23.15,13.38l-5.31-7.74c-.73-1.06-1.82-1.77-3.07-1.99-1.23-.22-2.49.07-3.52.8-.86.62-1.49,1.5-1.8,2.5,0-2.6-2.12-4.72-4.73-4.72S0,4.36,0,6.97v9.26c0,2.61,2.12,4.73,4.73,4.73s4.73-2.12,4.73-4.73v-6.37c.15.47.36.91.64,1.32l5.31,7.74c.73,1.06,1.82,1.77,3.07,1.99.27.05.54.07.81.07.96,0,1.9-.3,2.7-.87,2.13-1.53,2.66-4.54,1.16-6.72ZM21.1,18.86c-.69.5-1.54.69-2.37.54-.85-.15-1.58-.63-2.08-1.35l-.15-.21-2.04-2.97,5.29-3.71h0s2.12,3.08,2.12,3.08c1.03,1.5.68,3.57-.79,4.62ZM18.91,9.9l-5.3,3.71-2.26-3.3c-1.03-1.5-.68-3.57.79-4.62.54-.39,1.17-.59,1.82-.59.18,0,.36.02.55.05.85.15,1.58.63,2.08,1.35l2.33,3.4ZM7.93,12.36v3.87c0,1.77-1.44,3.21-3.21,3.21s-3.21-1.44-3.21-3.21v-3.87h6.41ZM7.93,6.97v3.87H1.52v-3.87c0-1.77,1.44-3.21,3.21-3.21s3.21,1.44,3.21,3.21Z",
      },
    ],
  ],
  "currentColor"
);
